import { createContext, useContext } from 'react';

export interface ShellInsets {
  /** Pixels on the left that the floating navigation rail covers, including its margin. */
  left: number;
}

const ShellInsetsContext = createContext<ShellInsets>({ left: 0 });

export const ShellInsetsProvider = ShellInsetsContext.Provider;

/**
 * How much of a full-bleed page is hidden beneath the floating chrome.
 *
 * <p>Needed because the navigation rail stopped being a layout sibling and became a glass
 * panel floating ON TOP of the content. That is what makes the glass mean anything -- it
 * has the map behind it to refract -- but it also means a full-bleed page can no longer
 * assume its own box is the visible area. Anything that must stay readable (a floating
 * card, the map's camera) offsets by this; the map canvas itself deliberately does not,
 * because running underneath is the whole point.
 */
export function useShellInsets(): ShellInsets {
  return useContext(ShellInsetsContext);
}
